import {capitalize} from "lodash";

export default function showTypeToParamName(showType) {
  return `show${capitalize(showType)}`
}